export default __webpack_public_path__ + "0be946bd9dff2d19df7a90cd2e837642.woff";